import { createSelector } from 'reselect';
import { initialState } from './reducer';
/**
 * Direct selector to the profilePage state domain
 */
export var selectProfilePageDomain = function (state) {
    return state.profilePage || initialState;
};
export var makeProfilePageDomain = function () {
    return createSelector(selectProfilePageDomain, function (pageState) { return pageState; });
};
/**
 * Other specific selectors
 */
/**
 * Default selector used by ProfilePage
 */
